import React from "react";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import photo from "../../../../assets/images/photo.png";
import "./PhotoAfterRepair.css";

var storage = firebase.storage();

class PhotoAfterRepair extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      image: null,
      url: "",
      uploadValue: 0,
    };
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  handleUpload = (e) => {
    const file = e.target.files[0];
    const storageRef = firebase.storage().ref(`images/${file.name}`);
    const task = storageRef.put(file);

    task.on(
      "state_changed",
      (snapshot) => {
        // progrss function ....
        let percentage =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        this.setState({
          uploadValue: percentage,
        });
        if (percentage === 100) {
          document.getElementById("progress").classList.add("d-none");
        }
      },
      (error) => {
        // error function ....
        console.log(error);
      },
      () => {
        // complete function ....
        storage
          .ref("images")
          .child(file.name)
          .getDownloadURL()
          .then((url) => {
            this.setState({ url: url });
            firebase.auth().onAuthStateChanged(function (user) {
              if (user) {
                let currentDentCollection = firebase
                  .firestore()
                  .collection("dent_info")
                  .doc(sessionStorage.getItem("idCard"));
                return currentDentCollection
                  .update({
                    imgAfterRepair: url,
                  })
                  .then(function () {
                    window.location.reload();
                  })
                  .catch(function (error) {
                    alert(error);
                  });
              }
            });
          });
      }
    );
  };
  render() {
    return (
      <div className="d-flex justify-content-start">
        <form>
          <input
            type="file"
            id="photoProfile"
            className="SubirFoto"
            accept="image/png, .jpeg, .jpg"
            onChange={this.handleUpload}
          />
          <label htmlFor="photoProfile">
            <img
              src={this.props.urlPhoto || photo}
              className="img-fluid mb-2"
              width="100"
              height="100"
              alt="Uploaded images"
            />
          </label>
          <progress
            id="progress"
            className="mt-1 sizeProgress"
            value={this.state.uploadValue}
            max="100"
          ></progress>
        </form>
      </div>
    );
  }
}
export default PhotoAfterRepair;
